import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PropertyMatrixWordmark from '../onboarding/PropertyMatrixWordmark';
import styles from '../stylesheets/mobileViewportGate.module.scss';

interface MobileViewportGateProps {
  children: React.ReactNode;
}

const MOBILE_MEDIA_QUERY = '(max-width: 640px)';
const MOBILE_TOUR_URL = 'https://app.propertymatrix.com/product-tour';

const getIsMobileViewport = () => {
  if (typeof window === 'undefined') {
    return true;
  }

  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

const MobileViewportGate = ({ children }: MobileViewportGateProps) => {
  const [isMobileViewport, setIsMobileViewport] = useState(getIsMobileViewport);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobileViewport(event.matches);
    };

    setIsMobileViewport(mediaQuery.matches);

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  if (isMobileViewport) {
    return <>{children}</>;
  }

  return (
    <div className={styles.root}>
      <section
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile view required"
      >
        <PropertyMatrixWordmark className={styles.logo} />
        <h1 className={styles.title}>Open this product tour from your phone</h1>
        <p className={styles.bodySecondary}>
          This experience is designed for mobile. Scan this QR code to continue
          on your phone.
        </p>
        <div className={styles.qrCodeContainer}>
          <div className={styles.qrCodeImage}>
            <QRCodeSVG
              value={MOBILE_TOUR_URL}
              size={220}
              level="M"
              includeMargin
              className={styles.qrCodeSvg}
              title="QR code for opening the product tour on mobile"
            />
          </div>
          <p className={styles.qrCodeCaption}>Scan with your phone camera</p>
        </div>
        <div className={styles.divider}></div>
        <p className={styles.bodySecondary}>
          Prefer a walkthrough instead? Book a demo with our team.
        </p>
        <button
          type="button"
          className={styles.primaryCta}
          onClick={() => {
            window.location.href =
              'https://www.propertymatrix.com/schedule_demo';
          }}
        >
          Book a demo
        </button>
      </section>
    </div>
  );
};

export default MobileViewportGate;
